import { useQuery } from "@tanstack/react-query"

import codeValueApi from "./codeValueApi"

const useAdMediaQuery = () => {
  const key = "codeValueApi.getAdMedia"
  const { data = [] } = useQuery([key], codeValueApi.getAdMedia, {
    select: (result) => (result.isSuccess ? result.data : []),
  })

  return data
}

export default useAdMediaQuery
